import DashboardHeader from './components/DashboardHeader';
import './dashboard.scss';
import DashboardItems from './components/DashboardItems';
import HelpeResource from './components/HelpeResource';
import AdditionalOptions from './components/AdditionalOptions';
import ContactUs from './components/ContactUs';
import NewsCenter from './components/NewsCenter';
import MessageCenter from './components/MessageCenter';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MaintainanceNotification from './components/MaintainanceNotification';
import React from 'react';
import { useMaintenanceNotificationMutation } from '../../features/authentication/authApiSlice';
import { useGetSchoolDistrictInfoMutation } from '../../features/authentication/dashboardHeaderApiSlice';
import { useDashboardContext } from '../dashboard/context';

const Welcome = () => {
  const [maintenanceNotification] = useMaintenanceNotificationMutation();
  const [maintenanceData, setMaintenanceData] = React.useState(null);
  const [schoolName, setSchoolName] = React.useState('');
  const [districtName, setDistrictName] = React.useState('');
  const [getSchoolInfo] = useGetSchoolDistrictInfoMutation();
  const getData = useDashboardContext();

  React.useEffect(() => {
    maintenancHandler();
    getSchoolDistrictInfoAsync();
  }, []);

  React.useEffect(() => {
    getSchoolDistrictInfoAsync();
  }, [getData.isSchoolChange]);

  const getSchoolDistrictInfoAsync = async () => {
    const response = await getSchoolInfo();
    setDistrictName(response.data.districtName);
    setSchoolName(response.data.schoolName);
  };

  const maintenancHandler = async () => {
    try{
      const response = await maintenanceNotification();
      const parser = new DOMParser();
      const errData = response.error !== undefined ? response.error.data : '';
      const html = parser.parseFromString(errData, 'text/html');
      const heading = html.querySelector('h3').textContent;
      const updateDate = html.querySelectorAll('p')[0].textContent;
      const message = html.querySelectorAll('p')[1].textContent;
      setMaintenanceData({
        heading,
        updateDate,
        message
      });
    } catch (ex){
      console.log(ex);
    }
  };
  //const user = useSelector(selectCurrentUser)
  //const token = useSelector(selectCurrentToken)

  //const welcome = user ? `Welcome ${user}!` : 'Welcome!'
  //const tokenAbbr = `${token.slice(0,9)}...`

  return (
    <>
      <div className="dashboard_main_wrapper">
        <MaintainanceNotification
          heading={maintenanceData?.heading}
          updateDate={maintenanceData?.updateDate}
          message={maintenanceData?.message}
          data={maintenanceData}
        />
        <section className="welcome">
          <DashboardHeader />
          <div className="row dashboard_second_header m-0 mb-4 p-3">
            <div className="col-lg-4 text-center border-end">
              {districtName != '' ? districtName + ' District' : 'District Name'}
            </div>
            <div className="col-lg-4 text-center border-end">
              {schoolName != '' ? schoolName : 'School Name'}
            </div>
            <div className="col-lg-4 text-center ">Teacher Center</div>
          </div>
          <DashboardItems />
          <HelpeResource />
          <div className="row">
            <div className="col-lg-6">
              <AdditionalOptions />
              <MessageCenter />
              <NewsCenter />
            </div>
            <ContactUs />
          </div>
        </section>
        <div className="col-12 info-text d-flex align-items-center">
          <span>
            <FontAwesomeIcon icon={faInfo} />
          </span>
          <p>
            Please remember to &quot;Logout&quot; when you are done. For best results, do not use
            your browser&apos;s BACK and FORWARD buttons while on Castle Learning.
          </p>
        </div>
      </div>
    </>
  );
};

export default Welcome;
